import { LoginService } from "@app/core/user/domain/services/login.service";
import { Injectable } from "@angular/core";
import { Credentials } from "@app/core/shared/domain/credentials";
import { Observable } from "rxjs";
import { LoginWS } from "@app/core/user/data/network/login.ws";
import { LoginResponse } from "@app/core/user/domain/login.reponse";

@Injectable()
export class LoginActionService implements LoginService {
  constructor(private loginWS: LoginWS) {}

  execute(credentials: Credentials): Observable<LoginResponse> {
    return this.loginWS.execute(credentials);
  }
}
